import { createContext, useContext } from 'react';

/**
 * Expone la ubicación actual del catálogo y cómo moverse dentro de ella.
 *
 * Existe porque el árbol de soluciones es recursivo (una solución contiene
 * subsoluciones que contienen subsoluciones) y todos los niveles necesitan poder
 * construir URLs. Pasarlo por props a través de la recursión sería un lío.
 */
export const CatalogRouteContext = createContext(null);

export function useCatalogRoute() {
    const value = useContext(CatalogRouteContext);
    if (!value) {
        throw new Error('useCatalogRoute se usó fuera de CatalogRouteContext.Provider');
    }
    return value;
}
